export const eventCategoriestableColumns = [
  {
    id: "name",
    label: "Category Name",
    minWidth: 70,
    align: "left",
  },
  {
    id: "image",
    label: "Image",
    minWidth: 70,
    align: "center",
    type: "IMAGE",
  },
  {
    id: "svg",
    label: "Icon",
    minWidth: 70,
    align: "center",
    type: "IMAGE",
  },
  {
    id: "isActive",
    label: "Active",
    minWidth: 70,
    align: "center",
  },
  {
    id: "action",
    label: "Action",
    minWidth: 100,
    align: "center",
  },
];

export const eventCategoriesformFields = [
  { name: "name", label: "Category Name", type: "text", required: true },
  {
    name: "image",
    label: "Category Image (.jpeg .jpg .png)",
    type: "file",
    required: true,
  },
  {
    name: "svg",
    label: "Category Icon (.svg)",
    type: "file",
    required: true,
  },
];
